import type {
  AddStakeholderRequestResponse,
  AddStakeholderRequestPayload,
  MatchStakeholdersRequestParams,
  MatchStakeholdersRequestResponse,
  AddStakeholderRequestParams
} from '@gat-ship/types'
import { useGsCloudBackend } from '@gat-ship/http-client'

export function useStakeholderApiCalls() {
  const { apiGet, apiPost } = useGsCloudBackend()

  /** Adds a new stakeholder to the system of a given type. NOTE! The stakeholder type controls which fields are required and which are allowed to be set. */
  async function addStakeholderRequest(params: AddStakeholderRequestParams) {
    return await apiPost<
      AddStakeholderRequestResponse,
      AddStakeholderRequestPayload
    >(`stakeholders`, params.payload, params.commandId)
  }

  /**
   * Searches for stakeholder that match certain parameters exactly. Typically used for duplicate checks during new registrations.
   * @param params - The parameters to match the stakeholders against.
   * @returns The list of stakeholders that match the parameters.
   */
  async function matchStakeholdersRequest(
    params: MatchStakeholdersRequestParams,
    config?: { signal?: AbortSignal }
  ) {
    return await apiGet<MatchStakeholdersRequestResponse>(
      `stakeholders/match`,
      {
        params,
        signal: config?.signal
      }
    )
  }

  return {
    addStakeholderRequest,
    matchStakeholdersRequest
  }
}
